
// Local storage utility for authentication
export const saveToken = (token: string) => {
  localStorage.setItem('auth_token', token);
};

export const getToken = (): string | null => {
  return localStorage.getItem('auth_token');
};

export const removeToken = () => {
  localStorage.removeItem('auth_token');
};

export const saveRefreshToken = (refreshToken: string) => {
  localStorage.setItem('refresh_token', refreshToken);
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem('refresh_token');
};

export const removeRefreshToken = () => {
  localStorage.removeItem('refresh_token');
};

export const saveUser = (user: any) => {
  localStorage.setItem('user_data', JSON.stringify(user));
};

export const getUser = () => {
  const userData = localStorage.getItem('user_data');
  return userData ? JSON.parse(userData) : null;
};

export const removeUser = () => {
  localStorage.removeItem('user_data');
};

export const clearAuth = () => {
  removeToken();
  removeRefreshToken();
  removeUser();
};
